"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKBOX_CATEGORY_KEY = 'base';
exports.CHECKBOX_COMPONENT_KEY = 'checkbox';
